import { render, staticRenderFns } from "./BrancePayment.vue?vue&type=template&id=b79dca18&"
import script from "./BrancePayment.vue?vue&type=script&lang=js&"
export * from "./BrancePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports